var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasData)?_c('e-chart',{attrs:{"options":_vm.chartOptions,"autoresize":""}}):_c('SpinnerCmpt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }